import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { showMessage } from '../common.slice';
const initialState = {
  guestList: [],
  guestListManagerN: [],
  guestListManagerY: [],
  guestLoading: false,
  isGuestUpdated: false,
  previousGuestList: [],
  importGuestList: [],
  guestMailTemplateList: [],
  guestEmailDetail: {},
  isGuestImported: false,
  isSendEmail: false,
  dynamicContent: {},
  mailListLoading: false,
  isImportGuestUpdated: false,
  guestListStatus: {},
};

export const getGuestListData = createAsyncThunk(
  'admin/get-guest-list-sdfs',
  (props, { dispatch }) => {
    const { booking_id, data } = props;
    return new Promise((resolve, reject) => {
      axios
        .post(`api/booking/${booking_id}/guestlist`, data)
        .then(res => {
          if (res.data.err === 0) {
            if (res.data.data.length > 0) {
              resolve(res.data.data);
            } else {
              resolve([]);
            }
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const createUpdateBookingGuest = createAsyncThunk(
  'admin/create-update-booking-guest',
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { booking_id, booking } = props;
      axios
        .post(`api/booking/${booking_id}/guest`, booking)
        .then(res => {
          if (res.data.err === 0) {
            dispatch(
              showMessage({ message: res.data.msg, varient: 'success' }),
            );
            resolve(res.data);
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const importPreviousGuest = createAsyncThunk(
  'admin/import-previous-guest',
  ({ booking_id, data }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/booking/${booking_id}/guest/import_previous`, data)
        .then(res => {
          if (res.data.err === 0) {
            dispatch(
              showMessage({ message: res.data.msg, varient: 'success' }),
            );
            resolve(res.data);
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const getPreviousGuestListData = createAsyncThunk(
  'admin/get-previous-guest-list',
  ({ booking_id }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`api/booking/${booking_id}/previous_guests`)
        .then(res => {
          if (res.data.err === 0) {
            if (res.data.data.length > 0) {
              resolve(res.data.data);
            } else {
              resolve([]);
            }
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const getImportGuestsListData = createAsyncThunk(
  'admin/get-import-guests-list',
  ({ booking_id, payload }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/booking/${booking_id}/guest/import`, payload)
        .then(res => {
          if (res.data.err === 0) {
            if (res.data.data.length > 0) {
              resolve(res.data.data);
              dispatch(
                showMessage({ message: 'File Upload', varient: 'success' }),
              );
            } else {
              resolve([]);
            }
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const getGuestListStatus = createAsyncThunk(
  'admin/get-guest-list-status',
  ({ booking_id }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`api/guest_status/${booking_id}`)
        .then(res => {
          if (res.data.err === 0) {
            if (Object.keys(res.data.data)) {
              resolve(res.data.data);
            } else {
              resolve([]);
            }
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const getGuestMailTemplateListData = createAsyncThunk(
  'admin/get-guest-mail-template-list',
  ({ data }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/guest_email`, data)
        .then(res => {
          if (res.data.err === 0) {
            if (res.data.data.length > 0) {
              resolve(res.data.data);
            } else {
              resolve([]);
            }
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const getGuestMailTemplateData = createAsyncThunk(
  'admin/get-guest-single-mail-template',
  ({ transactional_email_id }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/guest_email/${transactional_email_id}`)
        .then(res => {
          if (res.data.err === 0) {
            if (Object.keys(res.data.data).length > 0) {
              resolve(res.data.data);
            } else {
              resolve([]);
            }
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const sendEmail = createAsyncThunk(
  'admin/send-email',
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { payload } = props;
      axios
        .post(`api/email/send_email`, payload)
        .then(res => {
          if (res.data.err === 0) {
            dispatch(
              showMessage({ message: res.data.msg, varient: 'success' }),
            );
            resolve(res.data.data);
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const dynamicMailTemplate = createAsyncThunk(
  'admin/dynamic-mail-templete',
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .post('api/dynamicContent', data)
        .then(res => {
          if (res.data.err === 0) {
            resolve(res.data.data);
          } else {
            dispatch(showMessage({ message: res.data.msg }));
            reject();
          }
        })
        .catch(error => {
          dispatch(showMessage({ message: error.response.data.msg }));
          reject(error);
        });
    });
  },
);

export const guestSlice = createSlice({
  name: 'guest',
  initialState,
  reducers: {
    setIsGuestUpdated: (state, action) => {
      state.isGuestUpdated = action.payload;
    },
    setGuestEmailDetail: (state, action) => {
      state.guestEmailDetail = action.payload;
    },
    setImportGuestsListData: (state, action) => {
      state.importGuestList = action.payload;
    },
    setDynamicContent: (state, action) => {
      state.dynamicContent = action.payload;
    },
  },
  extraReducers: {
    [getGuestListData.fulfilled]: (state, action) => {
      state.guestList = action.payload;
      state.guestListManagerN = action.payload.filter(
        _ => !_.is_manager && !_.managed_by,
      );
      state.guestListManagerY = action.payload.filter(_ => _.is_manager);
    },
    [createUpdateBookingGuest.pending]: state => {
      state.isGuestUpdated = false;
      state.guestLoading = true;
    },
    [createUpdateBookingGuest.rejected]: state => {
      state.isGuestUpdated = false;
      state.guestLoading = false;
    },
    [createUpdateBookingGuest.fulfilled]: (state, action) => {
      state.isGuestUpdated = true;
      state.guestLoading = false;
    },
    [importPreviousGuest.pending]: state => {
      state.isGuestImported = false;
      state.guestLoading = true;
    },
    [importPreviousGuest.rejected]: state => {
      state.isGuestImported = false;
      state.guestLoading = false;
    },
    [importPreviousGuest.fulfilled]: (state, action) => {
      state.isGuestImported = true;
      state.guestLoading = false;
    },
    [getPreviousGuestListData.pending]: state => {
      state.guestLoading = true;
    },
    [getPreviousGuestListData.rejected]: state => {
      state.previousGuestList = [];
      state.guestLoading = false;
    },
    [getPreviousGuestListData.fulfilled]: (state, action) => {
      state.previousGuestList = action.payload;
      state.guestLoading = false;
    },
    [getImportGuestsListData.pending]: state => {
      state.guestLoading = true;
      state.isImportGuestUpdated = false;
    },
    [getImportGuestsListData.rejected]: state => {
      state.importGuestList = [];
      state.guestLoading = false;
      state.isImportGuestUpdated = false;
    },
    [getImportGuestsListData.fulfilled]: (state, action) => {
      state.importGuestList = action.payload;
      state.guestLoading = false;
      state.isImportGuestUpdated = true;
    },
    [getGuestMailTemplateListData.pending]: state => {
      state.guestLoading = true;
    },
    [getGuestMailTemplateListData.rejected]: state => {
      state.guestMailTemplateList = [];
      state.guestLoading = false;
    },
    [getGuestMailTemplateListData.fulfilled]: (state, action) => {
      state.guestMailTemplateList = action.payload;
      state.guestLoading = false;
    },
    [getGuestMailTemplateData.pending]: state => {
      state.guestLoading = true;
      state.guestEmailDetail = {};
    },
    [getGuestMailTemplateData.rejected]: state => {
      state.guestLoading = false;
      state.guestEmailDetail = {};
    },
    [getGuestMailTemplateData.fulfilled]: (state, action) => {
      state.guestLoading = false;
      state.guestEmailDetail = action.payload;
    },
    [sendEmail.pending]: state => {
      state.isSendEmail = false;
      state.guestLoading = true;
    },
    [sendEmail.rejected]: state => {
      state.isSendEmail = false;
      state.guestLoading = false;
    },
    [sendEmail.fulfilled]: state => {
      state.isSendEmail = true;
      state.guestLoading = false;
    },
    [dynamicMailTemplate.pending]: state => {
      state.mailListLoading = true;
      state.dynamicContent = {};
    },
    [dynamicMailTemplate.rejected]: state => {
      state.mailListLoading = false;
      state.dynamicContent = {};
    },
    [dynamicMailTemplate.fulfilled]: (state, action) => {
      state.mailListLoading = false;
      state.dynamicContent = action.payload;
    },
    [getGuestListStatus.pending]: state => {
      state.guestListStatus = {};
    },
    [getGuestListStatus.rejected]: state => {
      state.guestListStatus = {};
    },
    [getGuestListStatus.fulfilled]: (state, action) => {
      state.guestListStatus = action.payload;
    },
  },
});

export const {
  setIsGuestUpdated,
  setGuestEmailDetail,
  setDynamicContent,
  setImportGuestsListData,
} = guestSlice.actions;

export default guestSlice.reducer;
